/* app/js/src/components/videoContainer/videoContainer.component.scss */
div .videoContainer ul,
div ul {
  max-width: 30vw;
  z-index: 9;
  max-height: 40vh;
  overflow-y: scroll;
  background-color: #ffffff;
  border: 1px solid #e1e6eb;
  border-radius: 4px;
  list-style-type: none;
  padding: 0;
  -webkit-box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.2);
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.2);
}
.cursor-pointer {
  cursor: pointer;
}
div .videoContainer ul::-webkit-scrollbar,
div ul::-webkit-scrollbar {
  height: 11px;
  overflow: visible;
  width: 11px;
  opacity: 1;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
div .videoContainer ul::-webkit-scrollbar-button,
div ul::-webkit-scrollbar-button {
  height: 0;
  width: 0;
}
div .videoContainer ul::-webkit-scrollbar-corner,
div ul::-webkit-scrollbar-corner {
  background: transparent;
}
div ul::-webkit-scrollbar-thumb:hover {
  background-color: #b9bec9;
}
div .videoContainer ul::-webkit-scrollbar-thumb,
div ul::-webkit-scrollbar-thumb {
  background-color: #e3e6ea;
  background-clip: padding-box;
  border: solid transparent;
  border-width: 0 4px 0 4px;
  min-height: 28px;
  padding: 100px 0 0;
  border-radius: 10px;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
div ul::-webkit-scrollbar-thumb:hover {
  background-color: #b9bec9;
}
div ul::-webkit-scrollbar-track:hover {
  background-color: #eef2f6;
}
div .videoContainer ul::-webkit-scrollbar-track,
div ul::-webkit-scrollbar-track {
  background-clip: padding-box;
  border: solid transparent;
  border-width: 0 4px 0 4px;
}
video::-webkit-media-controls {
  display: none !important;
}
.hidden {
  display: none !important;
}
.right-gray-divider,
div .controls .progress-bar,
div .controls > button#subtitles,
div .controls > button#audio {
  border-width: 0 1px;
  border-style: solid;
  border-color: #e1e6eb;
}
.svg-selected svg,
div .controls > button#timecodeFormat svg,
div .controls > button#subtitles svg,
div .controls > button#audio svg {
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.svg-selected svg path,
div .controls > button#timecodeFormat svg path,
div .controls > button#subtitles svg path,
div .controls > button#audio svg path {
  fill: #7d8fa1;
}
.svg-selected.active svg.timecode-svg,
div .controls > button.active#timecodeFormat svg.timecode-svg,
div .controls > button.active#subtitles svg.timecode-svg,
div .controls > button.active#audio svg.timecode-svg {
  stroke: #40c4ff;
}
.svg-selected.active svg path,
div .controls > button.active#timecodeFormat svg path,
div .controls > button.active#subtitles svg path,
div .controls > button.active#audio svg path {
  fill: #40c4ff;
}
div {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
div ul {
  position: absolute;
  width: 150px;
  height: 100px !important;
  overflow: hidden !important;
  overflow-y: auto !important;
  right: 5px;
  bottom: 33px;
  border-radius: 4px;
  font-size: 0.8em;
  background-color: rgba(255, 255, 255, 0.9);
  margin-bottom: 0px;
  -webkit-animation-delay: 0;
  -webkit-animation-duration: 0.2s;
  -webkit-animation-name: fadeInFromBottom;
  -webkit-animation-fill-mode: forwards;
  -webkit-animation-iteration-count: 1;
  -moz-animation-delay: 0;
  -moz-animation-duration: 0.2s;
  -moz-animation-name: fadeInFromBottom;
  -moz-animation-fill-mode: forwards;
  -moz-animation-iteration-count: 1;
  -o-animation-delay: 0;
  -o-animation-duration: 0.2s;
  -o-animation-name: fadeInFromBottom;
  -o-animation-fill-mode: forwards;
  -o-animation-iteration-count: 1;
  animation-delay: 0;
  animation-duration: 0.2s;
  animation-name: fadeInFromBottom;
  animation-fill-mode: forwards;
  animation-iteration-count: 1;
}
div ul li {
  margin: 0;
  padding: 0 5%;
  text-transform: uppercase;
}
div .videoContainer {
  overflow: hidden;
  background-color: #eef2f6;
  height: calc(100% - 30px);
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
}
div .videoContainer .indicators {
  position: absolute;
  left: 1%;
  top: 10%;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-justify-content: space-evenly;
  -ms-flex-pack: space-evenly;
  justify-content: space-evenly;
  color: #ffffff;
  width: 130px;
  height: 1px;
  text-shadow: 2px 2px 2px #232f3a;
}
div .videoContainer .indicators h3 {
  background-color: black;
}
div .videoContainer .indicators.fullscreen {
  transform: scale(2);
  left: 1%;
  top: 52px;
}
div .videoContainer .indicators .animate-recording {
  margin-top: 5px;
  -webkit-animation-delay: 0.5s;
  -webkit-animation-duration: 1s;
  -webkit-animation-name: fadeOut;
  -webkit-animation-fill-mode: both;
  -webkit-animation-iteration-count: infinite;
  -webkit-animation-timing-function: cubic-bezier(0.6, 0.04, 0.54, 0.99);
  -webkit-animation-direction: alternate;
  -moz-animation-delay: 0.5s;
  -moz-animation-duration: 1s;
  -moz-animation-name: fadeOut;
  -moz-animation-fill-mode: both;
  -moz-animation-iteration-count: infinite;
  -moz-animation-timing-function: cubic-bezier(0.6, 0.04, 0.54, 0.99);
  -mox-animation-direction: alternate;
  -o-animation-delay: 0.5s;
  -o-animation-duration: 1s;
  -o-animation-name: fadeOut;
  -o-animation-fill-mode: both;
  -o-animation-iteration-count: infinite;
  -o-animation-timing-function: cubic-bezier(0.6, 0.04, 0.54, 0.99);
  -o-animation-direction: alternate;
  animation-delay: 0.5s;
  animation-duration: 1s;
  animation-name: fadeOut;
  animation-fill-mode: both;
  animation-iteration-count: infinite;
  animation-timing-function: cubic-bezier(0.6, 0.04, 0.54, 0.99);
  animation-direction: alternate;
}
div .videoContainer video {
  height: 100%;
  width: 100%;
  background-color: #232f3a;
}
div .videoContainer ul {
  position: absolute;
  width: 150px;
  height: 100px !important;
  overflow: hidden !important;
  overflow-y: auto !important;
  right: 5px;
  bottom: 33px;
  border-radius: 4px;
  font-size: 0.8em;
  background-color: rgba(255, 255, 255, 0.9);
  margin-bottom: 0px;
  -webkit-animation-delay: 0;
  -webkit-animation-duration: 0.2s;
  -webkit-animation-name: fadeInFromBottom;
  -webkit-animation-fill-mode: forwards;
  -webkit-animation-iteration-count: 1;
  -moz-animation-delay: 0;
  -moz-animation-duration: 0.2s;
  -moz-animation-name: fadeInFromBottom;
  -moz-animation-fill-mode: forwards;
  -moz-animation-iteration-count: 1;
  -o-animation-delay: 0;
  -o-animation-duration: 0.2s;
  -o-animation-name: fadeInFromBottom;
  -o-animation-fill-mode: forwards;
  -o-animation-iteration-count: 1;
  animation-delay: 0;
  animation-duration: 0.2s;
  animation-name: fadeInFromBottom;
  animation-fill-mode: forwards;
  animation-iteration-count: 1;
}
div .videoContainer ul li {
  margin: 0;
  padding: 0 5%;
  text-transform: uppercase;
}
div .videoContainer > .subtitles-container {
  position: absolute;
  top: 0;
  background-color: transparent;
  color: #fff;
  font-family: Sans-Serif;
}
div .videoContainer > .subtitles-container span {
  position: absolute;
  width: 90%;
  left: 5%;
  font-size: 100%;
  bottom: 8%;
  text-align: center;
  text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.5);
  white-space: normal;
  text-shadow:
    -1px -1px 0 #000,
    1px -1px 0 #000,
    -1px 1px 0 #000,
    1px 1px 0 #000;
}
div .videoContainer > .subtitles-container.rtlSubtitle {
  direction: rtl;
}
div .videoContainer > .subtitles-container.rtlSubtitle > span {
  direction: rtl;
}
div .videoContainer > .video-loader {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  position: absolute;
  background-color: rgb(0, 0, 0);
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
}
div .videoContainer > .video-loader svg path.background {
  stroke: #232f3a;
  stroke-width: 3px;
  fill: none;
}
div .videoContainer > .video-loader svg path.top {
  stroke: #40c4ff;
  stroke-width: 3px;
  fill: none;
  stroke-dasharray: 66;
  stroke-dashoffset: 0;
  -webkit-animation-delay: 0;
  -webkit-animation-duration: 1s;
  -webkit-animation-name: rotate;
  -webkit-animation-fill-mode: forwards;
  -webkit-animation-iteration-count: infinite;
  -webkit-animation-timing-function: cubic-bezier(0.5, 0.11, 0.4, 0.98);
  -moz-animation-delay: 0;
  -moz-animation-duration: 1s;
  -moz-animation-name: rotate;
  -moz-animation-fill-mode: forwards;
  -moz-animation-iteration-count: infinite;
  -moz-animation-timing-function: cubic-bezier(0.5, 0.11, 0.4, 0.98);
  -o-animation-delay: 0;
  -o-animation-duration: 1s;
  -o-animation-name: rotate;
  -o-animation-fill-mode: forwards;
  -o-animation-iteration-count: infinite;
  -o-animation-timing-function: cubic-bezier(0.5, 0.11, 0.4, 0.98);
  animation-delay: 0;
  animation-duration: 1s;
  animation-name: rotate;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-timing-function: cubic-bezier(0.5, 0.11, 0.4, 0.98);
  transform-origin: center center;
  -webkit-transform-origin: center center;
  -ms-transform-origin: center center;
}
div .videoContainer > .video-loader .slow-internet-message {
  color: #ffffff;
  text-align: center;
  font-size: 0.9em;
  position: absolute;
  bottom: 0;
  height: auto;
  top: auto;
}
div .videoContainer > .video-loader .slow-internet-message > span {
  font-weight: 600;
}
div .videoContainer > .video-loader .slow-internet-message p {
  max-width: 300px;
  margin: 12px auto;
}
div .videoContainer > .video-error {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  position: absolute;
  background-color: rgba(0, 0, 0, 0.9);
  color: #ffffff;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  flex-direction: column;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
}
div .videoContainer > .video-error span {
  display: block;
}
div .videoContainer > .video-error a {
  display: block;
  color: #ffffff;
  font-size: 0.8em;
  text-decoration: none;
}
div .videoContainer > .video-error a:hover {
  text-decoration: underline;
  color: #ffffff;
}
div .controls {
  border: 1px solid #e1e6eb;
  background-color: #ffffff;
  position: absolute;
  top: calc(100% - 30px);
  height: 30px;
  left: 0;
  z-index: 3;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}
div .controls > button {
  -webkit-flex: 1 0 0;
  -ms-flex: 1 0 0;
  flex: 1 0 0;
  border: none;
  background: none;
}
div .controls > button:focus {
  outline: none;
}
div .controls > button svg {
  display: block;
  margin: auto;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  -ms-transform: scale(1);
  -webkit-transform: scale(1);
  transform: scale(1);
  transform-origin: center center;
  -webkit-transform-origin: center center;
  -ms-transform-origin: center center;
}
div .controls > button:active svg {
  -ms-transform: scale(0.7);
  -webkit-transform: scale(0.7);
  transform: scale(0.7);
}
div .controls > button:active svg.timecode-svg {
  stroke: #232f3a;
}
div .controls > button:active svg path {
  fill: #232f3a;
}
div .controls > button:last-child {
  border-width: 0 0 0 1px;
  border-style: solid;
  border-color: #e1e6eb;
}
div .controls .progress-bar {
  padding: 0 10px;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}
div .controls .progress-bar .bracket {
  cursor: col-resize;
  opacity: 1;
  display: block;
  margin-top: -14px;
  float: left;
  height: 30px;
  padding-top: -5px;
  font-size: 20px;
  font-style: normal;
}
div .controls .progress-bar .bracket:hover {
  font-size: x-large;
  margin-top: -16px;
}
div .controls .progress-bar > i {
  display: block;
  width: 100%;
  background-color: #e1e6eb;
  height: 3px;
  position: relative;
  border-radius: 1.5px;
  cursor: pointer;
}
div .controls .progress-bar > i span:first-child {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 25%;
  height: 100%;
  background-color: #40c4ff;
  z-index: 2;
  border-radius: 1.5px;
}
div .controls .progress-bar > i span.time-tooltip {
  -webkit-transition: opacity 150ms ease-in;
  transition: opacity 150ms ease-in;
  font-style: normal;
  background-color: #232f3a;
  color: #ffffff;
  font-size: 0.7rem;
  padding: 0.3rem;
  position: absolute;
  top: -2rem;
  left: 0;
  pointer-events: none;
  cursor: default;
  border-radius: 2px;
  opacity: 0;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
div .controls .progress-bar > i span.time-tooltip:after {
  content: " ";
  position: absolute;
  left: calc(50% - 0.4rem);
  bottom: -0.6rem;
  border-top: 0.4rem solid #232f3a;
  border-right: 0.4rem solid rgba(0, 0, 255, 0);
  border-bottom: 0.4rem solid rgba(0, 0, 255, 0);
  border-left: 0.4rem solid rgba(0, 0, 255, 0);
}
div .controls .progress-bar > i span.time-tooltip.visible {
  opacity: 1;
}
div .controls .progress-bar > i > i {
  z-index: 1;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.1);
  pointer-events: none;
  -ms-transform: scale(0, 1);
  -webkit-transform: scale(0, 1);
  transform: scale(0, 1);
  transform-origin: center left;
  -webkit-transform-origin: center left;
}
div .controls .progress-bar > i::after {
  content: " ";
  position: absolute;
  top: -6px;
  left: -2.5%;
  height: 12px;
  display: block;
  width: 105%;
}
div .controls > section {
  -webkit-flex: 12 0 0;
  -ms-flex: 12 0 0;
  flex: 12 0 0;
}
div .controls button[disabled] {
  opacity: 0.4;
}
div .controls button[disabled]:active svg path {
  -ms-transform: scale(1);
  -webkit-transform: scale(1);
  transform: scale(1);
}
.play-trimmed svg {
  display: inline !important;
}
.play-trimmed span {
  vertical-align: text-top;
  font-size: 12px;
  margin-left: 2px;
}
.no-media-preview-container {
  overflow: hidden;
  background-color: black;
  height: calc(100% - 30px);
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  text-align: center;
  display: flex;
  justify-content: space-around;
  color: white;
  align-items: center;
  font-size: 16px;
}
/*# sourceMappingURL=videoContainer.component.css.map */
